import { ResolveFn } from '@angular/router';
import { CasiProjectLabel } from '../models/models.lib';
import { inject } from '@angular/core';
import { ProjectLabelService } from '../tracker/project-label.service';

export const projectLabelsResolver: ResolveFn<CasiProjectLabel> = (route, state) => {
  return inject(ProjectLabelService).get();
};
